import { FuelCard, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import ShieldLockIcon from 'components/ui/ShieldLockIcon';
import { DS_TOKENS } from 'constants/styled.contants';
import React from 'react';

const Unsearched = () => (
  <FuelCard backgroundColor={DS_TOKENS.color.support.blue.weak} style={{ width: '100%' }} data-testid="gr-unsearched">
    <FuelFlex defaultProps={{ padding: 'km4', gap: 'km4', alignItems: 'flex-start', width: '100%' }} slot="content">
      <ShieldLockIcon height={24} />
      <FuelFlex defaultProps={{ gap: 'km1', flexDirection: 'column' }}>
        <FuelTypography size="body-md" color="neutral-strong" weight="bold">
          Protegido pelo Frete Seguro!
        </FuelTypography>
        <FuelTypography size="caption" color="neutral-strong" weight="medium">
          O motorista pagou uma taxa e garantiu proteção extra, com consulta gratuita na GR e cobertura financeira para
          sua empresa em caso de roubo da carga.
        </FuelTypography>
      </FuelFlex>
    </FuelFlex>
  </FuelCard>
);

export default Unsearched;
